<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="narcoticsbox-template-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="65%"
            class="form-table-h360"
            :addButton="{ permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingSaveAsView="loadingSaveAsView"
        >
            <slot slot="filter">
                <el-col :md="6" :lg="4" :xl="3" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="wardAuth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <SaveAs :visible.sync="saveas.dialogFormVisible" :data="saveas.data" @save-success="saveAsSuccess"></SaveAs>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SaveAs from './SaveAs.vue'
export default {
    name: `NarcoticsBoxTemplate`,
    props: {

    },
    components: { SaveAs },
    data() {
        return {
            title: `备药模板`,
            dic_ward_id: undefined,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            url: { baseURL: `/api/AcisSystem/NarcoticsBoxTemplate`,
                get: () => {
                    return this.loadNarcoticsBoxTemplate()
                },
                getOne: (row) => {
                    return this.loadOne(row)
                },
                post: (row) => {
                    return this.saveOne(row)
                },
                put: (row) => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let r = _.groupBy(row.items, d => d.dic_drug.value)
                        let valid = true
                        _.forEach(r, (g) => {
                            if (g.length > 1 && valid) {
                                this.$message.warning(`含有重复药`)
                                valid = false
                            }
                        })
                        if (!valid) { reject(); return }
                        let req = this.myaxios.put(`/api/AcisSystem/NarcoticsBoxTemplate/Put`, {
                            'id': row.id,
                            'name': row.name,
                            'code': row.code,
                            'description': row.description,
                            'regions': row.region_type == 1 ? [{ 'owner': that.currentUser.username }] : row.dic_ward_ids.map(d => {
                                return {
                                    'sys_narcotics_box_id': row.id,
                                    'dic_operating_ward_id': _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    'dic_recovery_ward_id': _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            }),
                            'items': row.items.map(d => {
                                return {
                                    'id': d.id,
                                    'sys_narcotics_box_template_id': row.id,
                                    'dic_drug_id': d.dic_drug.value,
                                    'quantity': d.quantity,
                                    'batch_no': d.batch_no,
                                    'display_order': d.display_order
                                }
                            })
                        })
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                } }
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`]),
        wardAuth() {
            this.dic_ward_id = this.active_ward && this.active_ward.value
            return this.ward_auth
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                // searchable: true,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `type_count`,
                label: `药品种类`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `groupmultiselect`,
                prop: `dic_ward_ids`,
                label: `可用区域`,
                // width: "180",
                isListable: true,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: this.ward_auth
                // default:[this.dic_ward_id]
            }, {
                type: `string`,
                prop: `creator`,
                label: `创建人`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `datetime`,
                prop: `create_date`,
                label: `创建时间`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `180`,
                fixed: `right`,
                isListable: true,
                readonly: false,
                options: function(that, { row }) {
                    if (row.enum_surgery_status !== -1) {
                        return [{
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `另存为`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingSaveAsView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `DeleteData`,
                            permission: `default`
                        }]
                    } else {
                        return [{
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `supplies_template:update`
                        }]
                    }
                }
            }, {
                type: `table`,
                prop: `items`,
                label: `药品列表`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `140`,
                    isListable: true,
                    readonly: false
                }, {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true,
                    readonly: false,
                    options: `/api/AcisSystem/Drug/Search`,
                    change: (that, { row, area }) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                        req.then(data => {
                            this.$set(row, `spec`, data && data.spec)
                            this.$set(row, `unit`, data && data.drug_unit)
                        })
                    }
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `120`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_no`,
                    label: `批次号`,
                    width: `120`,
                    readonly: false,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `基数`,
                    width: `140`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }],
                colspan: 24,
                default: []
            }]
        }
    },
    methods: {
        loadNarcoticsBoxTemplate() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/NarcoticsBoxTemplate/Get/`)
                let that = this
                req.then(data => {
                    let groupId = _.groupBy(data, `id`)
                    let templates = []
                    _.forEach(groupId, (g) => {
                        let r = { ...g[0] }
                        r.dic_ward_ids = !r.owner && g.map(d => { return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`) })
                        if (that.dic_ward_id) {
                            if (_.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1) {
                                templates.push(r)
                            }
                        } else {
                            templates.push(r)
                        }
                    })
                    resolve(templates)
                })
            })
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBoxTemplate/Items/${row.id}`)
                req.then(data => {
                    let items = data && data.map(d => {
                        d.dic_drug = { label: d.drug.name, value: d.drug.id, jianpin: d.drug.abbr }
                        d.spec = d.drug.spec
                        d.unit = d.drug.drug_unit
                        return d
                    })
                    row.items = _.orderBy(items, `display_order`)
                    resolve(row)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`narcoticsbox-template-list`].ReloadListData()
        },
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let r = _.groupBy(row.items, d => d.dic_drug.value)
                let valid = true
                _.forEach(r, (g) => {
                    if (g.length > 1 && valid) {
                        this.$message.warning(`含有重复药`)
                        valid = false
                    }
                })
                if (!valid) { reject(); return }
                let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBoxTemplate/Post`, {
                    'name': row.name,
                    'code': row.code,
                    'description': row.description,
                    // "display_order":row.display_order,
                    'regions': row.region_type == 1 ? [{ 'owner': this.currentUser.username }] : row.dic_ward_ids.map(d => {
                        return {
                            // "sys_supplies_template_id": 0,
                            'dic_operating_ward_id': _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            'dic_recovery_ward_id': _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    }),
                    'items': row.items.map(d => {
                        return {
                            'id': d.id,
                            'sys_narcotics_box_template_id': row.id,
                            'dic_drug_id': d.dic_drug.value,
                            'batch_no': d.batch_no,
                            'quantity': d.quantity
                        }
                    })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadingSaveAsView({ row }) {
            this.loadOne(row).then(data => {
                let r = { ...data }
                this.saveas.dialogFormVisible = true
                r.name = ``
                r.id = 0
                this.saveas.data = r
            }).catch(e => {
                console.log(e)
            })
        },
        saveAsSuccess() {
            this.ReloadListData()
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NarcoticsBox/Template.vue